import { render, staticRenderFns } from "./ShiftWorkers.vue?vue&type=template&id=1180843c&"
import script from "./ShiftWorkers.vue?vue&type=script&lang=ts&"
export * from "./ShiftWorkers.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftWorkers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports